<template>
  <div style="width: 100%;height: 40px;line-height:40px; background-color: #1e9fff; color: #FFF;font-size: 16px;letter-spacing: 2px;overflow: hidden">
    <lay-row>
      <lay-col md="6">
        <div class="top-bar-bg">
          {{title}}
        </div>
      </lay-col>
      <lay-col md="12">
        <lay-notice-bar v-if="false" leftIcon="layui-icon-notice" mode="link" text="网络连接失败，无数据响应，请稍后重试。"></lay-notice-bar>
        <div v-else style="text-align: center">
          <lay-button :prefix-icon="alert.es1 ? 'layui-icon-tips' : 'layui-icon-ok-circle'"  size="xs"  :class="alert.es1 ? 'bling' : ''" :type="alert.es1 ? 'danger' : 'normal'" border-style="dashed" style="padding: 0 15px;" radius>1ES</lay-button>
          <lay-button :prefix-icon="alert.es2 ? 'layui-icon-tips' : 'layui-icon-ok-circle'"  size="xs"  :class="alert.es2 ? 'bling' : ''" :type="alert.es2 ? 'danger' : 'normal'" border-style="dashed" style="padding: 0 15px;" radius>2ES</lay-button>
          <lay-button :prefix-icon="alert.es3 ? 'layui-icon-tips' : 'layui-icon-ok-circle'"  size="xs"  :class="alert.es3 ? 'bling' : ''" :type="alert.es3 ? 'danger' : 'normal'" border-style="dashed" style="padding: 0 15px;" radius>3ES</lay-button>
          <lay-button :prefix-icon="alert.es4 ? 'layui-icon-tips' : 'layui-icon-ok-circle'"  size="xs"  :class="alert.es4 ? 'bling' : ''" :type="alert.es4 ? 'danger' : 'normal'" border-style="dashed" style="padding: 0 15px;" radius>4ES</lay-button>
        </div>
        <audio autoplay="autoplay" src="sounds/audio.mp3" v-if="isLogin && (alert.es1 || alert.es2 || alert.es3 || alert.es4)" loop></audio>
        <audio autoplay="autoplay" src="sounds/disconnection.mp3" v-if="alert.es1 && false" ></audio>
      </lay-col>
      <lay-col md="6">
        <div style="text-align: right">
          <lay-tag v-if="delay" type="normal">
            <template #icon>
              <lay-icon type="layui-icon-wifi" />
            </template>
            {{delay}}ms
          </lay-tag>
          <lay-button prefix-icon="layui-icon-ok-circle"  type="normal" style="padding: 0 5px;" @click="clearAlert">清闪消音</lay-button>
          <BarClock/>
          <lay-button prefix-icon="layui-icon-user"  type="normal" style="padding: 0 3px 0 0;" @click="logout">用户注销</lay-button>
         </div>
      </lay-col>
    </lay-row>
  </div>
</template>

<script setup>
import {defineProps} from "vue";
import {layer} from "@layui/layui-vue";
import BarClock from "@/components/BarClock";
import {useRouter} from "vue-router/dist/vue-router";
import useUtils from "@/assets/js/utils";
import axios from "axios";
import {useUpdateService} from "@/assets/js/updateService";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
defineProps(['title'])

let layerId = null, pageClearId = null;

let router = useRouter();

let {alert, isLogin, falseAlert} = useUtils();

let {delay} = useUpdateService();


useRealTimeDataService(service, null, {checkFR: false, alert: true});

function service(data){
  for (let key in data){
    if (data[key]?.alert){
      alert.value['es' + data[key]['sn'].split('-')[0]] = true;
    }
  }
}

const logout = () => {
  layerId = layer.confirm("退出登录?",
      {title: "", move: false, closeBtn: false,
        btn: [{text:'确认', callback: ()=> {
          layer.close(layerId);
          isLogin.value = false;
            router.push({path: '/login', replace: true})
            localStorage.removeItem("access_token");
        }},{text:'取消', callback: ()=>{ layer.close(layerId) }}]})
}


const clearAlert = () => {
  pageClearId = layer.confirm("是否清除所有报警及提示音?",
      {title: "", move: false, closeBtn: false,
        btn: [{text:'确认', callback: ()=> {
            clearAlertInfo();
            layer.close(pageClearId);
          }},{text:'取消', callback: ()=>{ layer.close(pageClearId) }}]})
}


function clearAlertInfo(){
  axios.get(`/page/clear`) .then(function (response) {
    if (response.data.code == 0){
      falseAlert();
    }
  })
}

</script>

<style scoped>
.top-bar-bg{
  text-indent: 5px;
}
.user-avatar{
  background: url("../assets/user.png") no-repeat 20px center;
  text-indent: 50px;
  text-align: right;
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
}
</style>